import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const newsDeleteEndpoint = ApiEndpoints.caseStudy.caseStudyDelete;
const newsListEndpoint = ApiEndpoints.caseStudy.caseStudyList;
const newsEditPath = "edit-case";
const tableHeader = ["Date", "Title", "Slug"];
const tbody = ["createdAt", "title", "slug"];

export default function CaseListing() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", newsListEndpoint);
      const result = response.casestudys;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (casestudy_id) => {
    const payload = { casestudy_id };
    try {
      const response = await ApiRequest("POST", newsDeleteEndpoint, payload);
      toast.success(response.message);
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  const pagename = {
    name: 'Case Management',
    user: 'Admin',
    innerpage: 'Case Management / case Study'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-case">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={newsEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  )
}
